import { HznDropdown } from "./dropdown/dropdown.js";
import { defineHorizonElement } from "@horizon/common/helpers";
import "./types.js";
defineHorizonElement("hzn-dropdown", HznDropdown);
//# sourceMappingURL=hzn-dropdown.js.map
